export default "__VITE_ASSET__DkWNLaMg__"